import { render, staticRenderFns } from "./m-product-add-to-cart.vue?vue&type=template&id=9652c738&scoped=true&"
import script from "./m-product-add-to-cart.vue?vue&type=script&lang=js&"
export * from "./m-product-add-to-cart.vue?vue&type=script&lang=js&"
import style0 from "./m-product-add-to-cart.vue?vue&type=style&index=0&id=9652c738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9652c738",
  null
  
)

export default component.exports